import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock'

import { LIVE_SITE_URL } from '@constants'
import useClearTimeout from 'hooks/useClearTimeout'

import s from './BoardsToggle.module.css'

function BoardsMenu({
  boardToggled = false,
  handleBoardToggle = () => {},
  handleFollowersToggle = () => {},
  handleTownToggled = () => {},
  className = '',
  site = '',
}) {
  const router = useRouter()
  const [shareText, setShareText] = useState('Share Board')
  const [timeoutId, setTimeoutId] = useState(null)

  useClearTimeout(timeoutId)

  useEffect(() => {
    if (boardToggled) {
      disableBodyScroll()
    } else {
      clearAllBodyScrollLocks()
    }

    return () => clearAllBodyScrollLocks()
  }, [boardToggled])

  const pageLink = `${LIVE_SITE_URL}${router.asPath}`

  const handleShare = () => {
    let copyLink = document.getElementById('board-share-link')
    copyLink.select()
    document.execCommand('copy')

    setShareText('Link copied')
    const timeoutId = setTimeout(() => {
      setShareText('Share Board')
    }, 1000)
    setTimeoutId(timeoutId)
  }

  return (
    <>
      <div
        className={classNames(s.container, className, {
          [s.containerToggled]: boardToggled === true,
        })}
      >
        <button type="button" className={s.btn} onClick={handleBoardToggle}>
          <span />
        </button>
        <div className={s.menu}>
          {!['london', 'milano'].includes(site) && (
            <div className={classNames(s.menuItem, s.mobileOnly)}>
              <div className={s.toggle}>
                <input type="checkbox" onClick={handleTownToggled} />
                <div />
                <span className={s.menuLabel}>In Town</span>
              </div>
            </div>
          )}
          <div className={s.menuItem}>
            <div className={s.toggle}>
              <input type="checkbox" onClick={handleFollowersToggle} />
              <div />
              <span className={s.menuLabel}>Show followers</span>
            </div>
          </div>
          <div className={s.menuItem}>
            <button type="button" className={s.shareBtn} onClick={handleShare}>
              <span className={s.menuLabel}>{shareText}</span>
              <input
                id="board-share-link"
                className={s.shareLink}
                type="text"
                defaultValue={pageLink}
              />
            </button>
          </div>
        </div>
      </div>
      <button type="button" className={s.overlay} onClick={handleBoardToggle} />
    </>
  )
}

BoardsMenu.propTypes = {
  boardToggled: PropTypes.bool,
  handleBoardToggle: PropTypes.func,
  handleFollowersToggle: PropTypes.func,
  handleTownToggled: PropTypes.func,
  className: PropTypes.string,
  site: PropTypes.string,
}

export default BoardsMenu
